import { useToast } from '@/hooks/useToast';
import { useState } from 'react';
import { convertHeicPhotos } from './convertHeicPhotos';
import { isHeifFile } from './heicFiles';

export interface HeicConversionProgress {
  photoNumber: number;
  total: number;
}

const unconvertedMessage = (names: string[]): string =>
  `${names.join(', ')} couldn't be converted in this browser. Export ${names.length > 1 ? 'them' : 'it'} as JPEG and try again.`;

export const useHeicConversion = () => {
  const [conversion, setConversion] = useState<HeicConversionProgress>();
  const { showToast } = useToast();

  const convertForBrowser = async (files: File[]): Promise<File[]> => {
    const total = files.filter(file => isHeifFile(file)).length;
    const { photos, unconverted } = await convertHeicPhotos(files, photoNumber =>
      setConversion({ photoNumber, total })
    );
    setConversion(undefined);
    if (unconverted.length > 0) {
      showToast({ message: unconvertedMessage(unconverted), type: 'warning' });
    }
    return photos;
  };

  return { conversion, convertForBrowser };
};
